import { ActionButton } from '@emerald-works-nova/components'
import { Accordion, AccordionDetails, AccordionSummary, Box, FormControlLabel, Grid, Switch, Typography } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'
import classNames from 'classnames'
import React from 'react'
import { Controller } from 'react-hook-form'
import { ColourSchemes } from '../../../reducers/campaign-edit/slice'
import { useCampaignFormContext } from '../campaign-form-context'
import { ReviewInformationPanel } from '../components'
import { useStyles } from './style'

const ACCORDION_TABS = {
  homePage: 'homepage',
  exploreMenu: 'explore-menu',
  categoryPage: 'category-page',
  articleVertical: 'article-vertical',
  articleHorizontal: 'article-horizontal'
}

const ReviewTab = () => {
  const { form, mainClasses } = useCampaignFormContext()
  const campaign = React.useMemo(() => form.getValues(), [form])
  const colourScheme = form.watch('colourScheme')
  const { bg, btn, btnText, text } = ColourSchemes[colourScheme] || {}
  const classes = useStyles({ bg, btn, btnText, text })
  const [expanded, setExpanded] = React.useState(ACCORDION_TABS.homePage)

  const handleChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <Grid className={classes.root}>
      <Grid container alignItems='center' className={mainClasses.ctnTitle}>
        <Grid item xs={8}>
          <Typography variant='h6'>Banners Preview</Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={9} className={classes.accordionRoot}>
          <Accordion
            elevation={0}
            classes={{ root: classes.accordion, expanded: classes.accordionExapanded }}
            expanded={expanded === ACCORDION_TABS.homePage}
            onChange={handleChange(ACCORDION_TABS.homePage)}
          >
            <AccordionSummary
              classes={{ root: classes.summary }}
              expandIcon={<ExpandMore />}
              aria-controls='panel-basic'
              id='panel-basic-header'
            >
              <Typography
                className={classNames(classes.heading, { [classes.headingActive]: expanded === ACCORDION_TABS.homePage })}
                data-test='home-page'
              >
                Homepage Banner
              </Typography>
            </AccordionSummary>
            <AccordionDetails classes={{ root: classes.detail }}>
              <Grid className={classes.homePageBannerCtn} container>
                <Grid item xs={7} className={classes.homePageBannerTxtCtn}>
                  <Typography className={classes.homePageBannerTitle} variant='h5'>{campaign.title}</Typography>
                  <Typography
                    variant='body2'
                    className={classes.homePageBannerDescription}
                    dangerouslySetInnerHTML={{ __html: campaign.body }}
                  />
                  <ActionButton variant='primary' dataTest='banner-button' className={classes.bannerBtn}>
                    {campaign.ctaText}
                  </ActionButton>
                </Grid>
                <Grid item xs={5}>
                  <img src={campaign.rectangularImg?.imgUrl} className={classes.homePageBannerImg} />
                </Grid>
              </Grid>
              <Grid container>
                <Box mt={1} mb={1} width='100%'>
                  <Typography>You can hide the banner from the Homepage if don't want to show this campaign.</Typography>
                </Box>
                <Controller
                  name='enableHomeBanner'
                  control={form.control}
                  defaultValue
                  render={({ field }) => (
                    <FormControlLabel
                      label={`Banner ${field.value === true ? 'On' : 'Off'}`} control={
                        <Switch {...field} checked={field.value} color='primary' />
                      }
                    />
                  )}
                />
              </Grid>
            </AccordionDetails>
          </Accordion>
          <Accordion
            elevation={0}
            classes={{ root: classes.accordion, expanded: classes.accordionExapanded }}
            expanded={expanded === ACCORDION_TABS.exploreMenu}
            onChange={handleChange(ACCORDION_TABS.exploreMenu)}
          >
            <AccordionSummary
              classes={{ root: classes.summary }}
              expandIcon={<ExpandMore />}
              aria-controls='panel-basic'
              id='panel-basic-header'
            >
              <Typography
                className={classNames(classes.heading, { [classes.headingActive]: expanded === ACCORDION_TABS.exploreMenu })}
                data-test='explore-menu'
              >
                Explore Menu Horizontal Banner
              </Typography>
            </AccordionSummary>
            <AccordionDetails classes={{ root: classes.detail }}>
              <Box className={classes.exploreMenuBannerEdge}>
                <Grid className={classNames(classes.exploreMenuBannerCtn, classes.exploreMenuBannerCard)} container>
                  <Grid item className={classes.exploreMenuImgCtn}>
                    <img src={campaign.squareImg?.imgUrl} className={classes.exploreMenuBannerImg} />
                  </Grid>
                  <Grid item xs className={classes.exploreMenuBannerTxtCtn}>
                    <Typography className={classes.exploreMenuBannerTitle} variant='h5'>{campaign.title}</Typography>
                    <Typography
                      className={classes.exploreMenuBannerDescription}
                      variant='body2'
                      dangerouslySetInnerHTML={{ __html: campaign.body }}
                    />
                    <ActionButton variant='primary' dataTest='banner-button' className={classes.bannerBtn}>
                      {campaign.ctaText}
                    </ActionButton>
                  </Grid>
                </Grid>
              </Box>
            </AccordionDetails>
          </Accordion>
          <Accordion
            elevation={0}
            classes={{ root: classes.accordion, expanded: classes.accordionExapanded }}
            expanded={expanded === ACCORDION_TABS.categoryPage}
            onChange={handleChange(ACCORDION_TABS.categoryPage)}
          >
            <AccordionSummary
              classes={{ root: classes.summary }}
              expandIcon={<ExpandMore />}
              aria-controls='panel-basic'
              id='panel-basic-header'
            >
              <Typography
                className={classNames(classes.heading, { [classes.headingActive]: expanded === ACCORDION_TABS.categoryPage })}
                data-test='category-page'
              >
                Category Page Vertical Banner
              </Typography>
            </AccordionSummary>
            <AccordionDetails classes={{ root: classes.detail }}>
              <Box className={classes.verticalBannerEdge}>
                <Grid className={classNames(classes.verticalBannerCtn, classes.verticalBannerCard)} container direction='row'>
                  <Grid item xs={12}>
                    <img src={campaign.squareImg?.imgUrl} className={classes.verticalBannerImg} />
                  </Grid>
                  <Grid item xs={12} className={classes.verticalBannerTxtCtn}>
                    <Typography className={classes.verticalBannerTitle} variant='h5'>{campaign.title}</Typography>
                    <Typography
                      variant='body2'
                      className={classes.verticalBannerDescription}
                      dangerouslySetInnerHTML={{ __html: campaign.body }}
                    />
                    <ActionButton variant='primary' dataTest='banner-button' className={classes.bannerBtn}>
                      {campaign.ctaText}
                    </ActionButton>
                  </Grid>
                </Grid>
              </Box>
            </AccordionDetails>
          </Accordion>
          <Accordion
            elevation={0}
            classes={{ root: classes.accordion, expanded: classes.accordionExapanded }}
            expanded={expanded === ACCORDION_TABS.articleVertical}
            onChange={handleChange(ACCORDION_TABS.articleVertical)}
          >
            <AccordionSummary
              classes={{ root: classes.summary }}
              expandIcon={<ExpandMore />}
              aria-controls='panel-basic'
              id='panel-basic-header'
            >
              <Typography
                className={classNames(classes.heading, { [classes.headingActive]: expanded === ACCORDION_TABS.articleVertical })}
                data-test='article-vertical'
              >
                Article Vertical Banner
              </Typography>
            </AccordionSummary>
            <AccordionDetails classes={{ root: classes.detail }}>
              <Box className={classes.verticalBannerEdge}>
                <Grid className={classNames(classes.verticalBannerCtn, classes.verticalBannerCard)} container direction='row'>
                  <Grid item xs={12}>
                    <img src={campaign.squareImg?.imgUrl} className={classes.verticalBannerImg} />
                  </Grid>
                  <Grid item xs={12} className={classes.verticalBannerTxtCtn}>
                    <Typography className={classes.verticalBannerTitle} variant='h5'>{campaign.title}</Typography>
                    <Typography
                      variant='body2'
                      className={classes.verticalBannerDescription}
                      dangerouslySetInnerHTML={{ __html: campaign.body }}
                    />
                    <ActionButton variant='primary' dataTest='banner-button' className={classes.bannerBtn}>
                      {campaign.ctaText}
                    </ActionButton>
                  </Grid>
                </Grid>
              </Box>
            </AccordionDetails>
          </Accordion>
          <Accordion
            elevation={0}
            classes={{ root: classes.accordion, expanded: classes.accordionExapanded }}
            expanded={expanded === ACCORDION_TABS.articleHorizontal}
            onChange={handleChange(ACCORDION_TABS.articleHorizontal)}
          >
            <AccordionSummary
              classes={{ root: classes.summary }}
              expandIcon={<ExpandMore />}
              aria-controls='panel-basic'
              id='panel-basic-header'
            >
              <Typography
                className={classNames(classes.heading, { [classes.headingActive]: expanded === ACCORDION_TABS.articleHorizontal })}
                data-test='article-vertical'
              >
                Article Horizontal Banner
              </Typography>
            </AccordionSummary>
            <AccordionDetails classes={{ root: classes.detail }}>
              <Box className={classes.articleHorizontalBannerEdge}>
                <Grid className={classNames(classes.articleHorizontalBannerCtn, classes.articleHorizontalBannerCard)} container>
                  <Grid item xs={5}>
                    <img src={campaign.squareImg?.imgUrl} className={classes.articleHorizontalBannerImg} />
                  </Grid>
                  <Grid item xs={7} className={classes.articleHorizontalBannerTxtCtn}>
                    <Typography className={classes.articleHorizontalBannerTitle} variant='h5'>{campaign.title}</Typography>
                    <Typography
                      variant='body2'
                      className={classes.articleHorizontalBannerDescription}
                      dangerouslySetInnerHTML={{ __html: campaign.body }}
                    />
                    <ActionButton variant='primary' dataTest='banner-button' className={classes.bannerBtn}>
                      {campaign.ctaText}
                    </ActionButton>
                  </Grid>
                </Grid>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item xs={3}>
          <ReviewInformationPanel />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ReviewTab
